import ReactDOM from 'react-dom/client';
import { App } from 'src/App.tsx';
import '../index.css';
import { SentryMonitoringService } from '@libs/frontend-services';
import { SENTRY_DSN, VITE_ENV, SENTRY_RELEASE, SENTRY_ENABLED } from 'src/config';

// Initialize Sentry with production-first defaults and environment-specific privacy settings
const isProduction = VITE_ENV === 'production';
const monitoringService = new SentryMonitoringService();
monitoringService.init({
  dsn: SENTRY_DSN,
  environment: VITE_ENV,
  release: SENTRY_RELEASE,
  sendDefaultPii: isProduction,
  sessionReplaySampleRate: isProduction ? 0.1 : 0,
  errorReplaySampleRate: isProduction ? 1.0 : 0.5,
  enableLogs: isProduction,
  enabled: SENTRY_ENABLED,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  // google maps handles markers in a weird way that prevents us from enabling strict mode
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
);
